import React from 'react';
import TableHandler from '../TableHandler';
import { Table, Thead, Th, Tr, Td } from 'reactable';
import '../../css/tables/reactable.css';
import hasAccess from "../../helpers/permissionChecker";

const buildHandlers = function(handlersList, id, currentItem) {
  const arrayHandlers = [];

  for (let action in handlersList) {
    let item = handlersList[action];
    let isShow = true;
    if (item.permission) {
      if (item.authorColumnName) {
        item.permission.idForCheckingAuthor = currentItem[item.authorColumnName];
      }
      isShow = hasAccess(item.permission);
    }
    if (isShow) {
      arrayHandlers.push(
        <TableHandler
          item={currentItem}
          icon={item.icon}
          handler={item.handler}
          id={id}
          title={item.title}
          context={item.context}
          iconClass={item.iconClass}
          hasWrapper={item.hasWrapper}
          bind={item.bind}
          itemId={item.itemId}
        />
      );
    }
  }
  return arrayHandlers;
};

const getContainer = function(item, column, rowContainers) {
  if (!rowContainers || !rowContainers[column]) {
    return item;
  }
  const Container = rowContainers[column];
  return <Container option={item}/>;
};

const setTD = function(item, column, j, rowContainers, itemsForSortingFiltering, iterationKey) {
  const valueForSortFilt = itemsForSortingFiltering.length > 0 && itemsForSortingFiltering[iterationKey][column] ?
    itemsForSortingFiltering[iterationKey][column] : getContainer(item[column], column, rowContainers);
  return (
    <Td key={j} column={column} value={valueForSortFilt} data={getContainer(item[column], column, rowContainers)}>
      {getContainer(item[column], column, rowContainers)}
    </Td>
  );
};

const customPagination = (currentPage, onChangeCurrentPage, items, itemsPerPage) => {
  // elem.parentNode.removeChild(elem);
  const amountOfPages = Math.ceil(items.length / itemsPerPage);
  const previousPage = currentPage > 0 ?
    <a className="reactable-previous-page" onClick={() => onChangeCurrentPage(currentPage - 1)}>Previous</a>
    : null;
  const nextPage = amountOfPages > 1 && currentPage + 1 < amountOfPages ?
    <a className="reactable-next-page" onClick={() => onChangeCurrentPage(currentPage + 1)}>Next</a>
    : null;
  const allPages = [];
  const rangeStart = currentPage > 0 ? currentPage - 1 : currentPage;
  const rangeEnd = amountOfPages > 4 && rangeStart + 4 < amountOfPages ? rangeStart + 4 : amountOfPages;
  const lastPage = rangeEnd < amountOfPages ?
    (
      <a
        key={amountOfPages - 1}
        className='reactable-page-button'
        onClick={() => onChangeCurrentPage(amountOfPages - 1)}
      >
        {amountOfPages}
      </a>
    ) : null;

  for (let page = rangeStart; page < rangeEnd; page++) {
    const className = 'reactable-page-button' + (currentPage === page ? ' reactable-current-page' : '');
    allPages.push(
      <a
        key={page}
        className={className}
        onClick={() => onChangeCurrentPage(page)}
      >
        {page + 1}
      </a>)
  }

  return (
    <table className="reactable-pagination-table">
      <tbody className="reactable-pagination">
      <tr>
        <td colSpan="3">
          {previousPage}
          {allPages.map(value => value)}
          {lastPage && `...`}{lastPage}
          {nextPage}
        </td>
      </tr>
      </tbody>
    </table>
  )
};

const checkRole  = (item, roles) => {
  const arr = [1,2,3,4,5];
  let isRemovableId = true;
  arr.forEach(id =>{
    if(item.id === id) { isRemovableId = false }
  });
  return roles ? isRemovableId : true;
};

const wrap = (component, condition, clasName) => {
  if (condition) {
    return <div className={clasName}>{component}</div>;
  } else 
  return component;
}

const DefaultTable = ({
                        items,
                        roles,
                        columns,
                        columnNames,
                        itemsPerPage,
                        search,
                        onSearch,
                        hideSearch,
                        onChangeItemsPerPage,
                        actions,
                        rowContainers,
                        itemsForSortingFiltering,
                        currentPage,
                        onChangeCurrentPage,
                        sortable,
                        markColumnWithClassName,
                        wrapTableInDiv,
                        defaultSort
                      }) => {
  let thOptions = [];
  if (actions && Object.keys(actions).length > 0) {
    thOptions = <Th column={'actions'}>{'Options'}</Th>;
  }
  return (
    <div>
      <div className="clearfix">

        <div className="pull-left">
          <form onSubmit={e => e.preventDefault()} className="pull-right">
            <div className="form-group form-inline">
              <select
                className="custom-select m-r-10"
                onChange={onChangeItemsPerPage}
                value={itemsPerPage}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </form>
        </div>

        {!!!hideSearch &&
          <div className="pull-right">
          <form onSubmit={e => e.preventDefault()}>
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-addon rounded-left">
                  <i className="sli-magnifier"></i>
                </div>
                <input
                  className="form-control rounded-right"
                  type="text"
                  value={search}
                  onChange={onSearch}
                />
              </div>
            </div>
          </form>
        </div>
        }
      </div>
      <div className="row">
        <div className="col-md-12">
          {wrap((
          <Table
            className="table"
            itemsPerPage={itemsPerPage}
            pageButtonLimit={5}
            sortable={sortable || true}
            filterable={columns}
            hideFilterInput
            filterBy={search}
            noDataText="No matching records found"
            currentPage={currentPage}
            defaultSort={defaultSort}
          >
            <Thead>
            {thOptions}
            {columns.map((column, i) => (
              <Th key={i} column={column} {...(markColumnWithClassName ? { 'className': 'table_' + columns[i] } : {}) } >
                {columnNames[i]}
              </Th>
            ))}
            </Thead>
            {items.map((item, i) => (
                <Tr key={i}>
                  {<Td column={'actions'}>
                    <div className="row" style={{ margin: 0, flexWrap: 'nowrap' }}>
                      {buildHandlers(checkRole(item, roles) ? actions : {edit: actions.edit}, item.id, item)}
                    </div>
                  </Td>}
                  {columns.map((column, j) => setTD(item, column, j, rowContainers, itemsForSortingFiltering, i))}
                </Tr>
              )
            )}
          </Table>), wrapTableInDiv, 'table-wrapper')}
          {customPagination(currentPage, onChangeCurrentPage, items, itemsPerPage)}
        </div>
      </div>
    </div>
  )
}
DefaultTable.defaultProps = {
  items: [],
  columns: [],
  itemsPerPage: 20,
  text: '',
  itemsForSortingFiltering: []
}
export default DefaultTable



// WEBPACK FOOTER //
// ./src/сomponents/Table/index.js